module.exports = __webpack_public_path__ + "Frame41.svg?f598b91b145dcfa7878b6c4fdca88261";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame41.svg
// module id = 91
// module chunks = 0